import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { Subscriber } from 'rxjs/Subscriber'

import { ConfirmOptions, ConfirmStyle } from './confirm.options'

@Injectable()
export class ConfirmService {
  private confirmsObservable: Observable<ConfirmOptions>
  private confirmsSubscriber: Subscriber<ConfirmOptions>

  constructor() {
    this.confirmsObservable = new Observable<ConfirmOptions>((subscriber: Subscriber<ConfirmOptions>) => {
      this.confirmsSubscriber = subscriber
    })
  }

  show(options: Object) {
    let confirmOptions = <ConfirmOptions>{
      title:          options['title'] || 'Подтвердите',
      text:           options['text'] || '',
      html:           options['html'],
      confirmBtnText: options['confirmBtnText'] || 'Подтвердить',
      cancelBtnText:  options['cancelBtnText'] || 'Отменить',
      confirmFn:      options['confirmFn'] || function() {},
      cancelFn:       options['cancelFn'] || function() {},
      onlyConfirm:    options['onlyConfirm'] || false,
      style:          options['style'] || ConfirmStyle.default
    }
    this.confirmsSubscriber.next(confirmOptions)
  }

  getConfirms(): Observable<ConfirmOptions> {
    return this.confirmsObservable
  } 
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/confirm/confirm.service.ts